<script>
import {
  Line,
} from "vue-chartjs"

export default Line.extend({
  name: 'history-chart',
  props: ['chartData', 'barrier', 'settings'],
  data() {
    return {
      options: {
        responsive: false,
        responsiveAnimationDuration: 0,
        animation: {
          duration: 0,
        },
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 20,
            bottom: 20,
          },
        },
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            fontSize: 35,
            boxWidth: 100,
            padding: 20,
          },
        },
        title: {
          display: false,
        },
        scales: {
          xAxes: [{
            type: 'time',
            ticks: null,
            gridLines: {
              display: true,
              lineWidth: 4,
              drawBorder: false,
              zeroLineColor: 'transparent',
              drawOnChartArea: false,  // Disable default gridlines
              zeroLineWidth: 0,
              drawTicks: false,        // Disable tick marks
              tickMarkLength: 0,
            },
            time: {
              unit: 'day',
              displayFormats: {
                day: 'DD.MM.YYYY',
                month: 'MMM YYYY',
                year: 'YYYY',
              },
            },
          }],
          yAxes: [{
            ticks: {
              maxTicksLimit: 7,
              beginAtZero: false,
              fontSize: 35,
              fontColor: "black",
              padding: 40,
              callback(value, index, values) {
                return value + ' %'
              },
            },
            gridLines: {
              display: true,
              drawBorder: false,
              lineWidth: 4,
              zeroLineWidth: 4,
            },
          }],
        },
      },
    }
  },
  mounted() {
    this.chartData.datasets.forEach((dataset, index) => {
      this.chartData.datasets[index].data = this.fillMissingDataPoints(dataset.data)
    })

    console.log(this.chartData)

    let yearlyTicks = this.createYearlyTicks(this.chartData.datasets[0].data)
    this.options.scales.xAxes[0].ticks = this.createTickConfiguration(yearlyTicks)

    // Store yearlyTicks for use in the plugin
    this.yearlyTicks = yearlyTicks

    Chart.plugins.register({
      id: 'customGridlines',
      beforeDraw: (chart) => {
        const ctx = chart.ctx
        const xAxis = chart.scales['x-axis-0']
        const yAxis = chart.scales['y-axis-0']
        const overshoot = 30 // pixels to extend beyond chart area

        if (!xAxis || !yAxis) return

        ctx.save()

        // Draw horizontal line at y=0
        const yPixel = yAxis.getPixelForValue(0)
        if (yPixel >= chart.chartArea.top && yPixel <= chart.chartArea.bottom) {
          ctx.strokeStyle = '#000000'
          ctx.lineWidth = 2
          ctx.setLineDash([])
          ctx.beginPath()
          ctx.moveTo(chart.chartArea.left, yPixel)
          ctx.lineTo(chart.chartArea.right, yPixel)
          ctx.stroke()
        }

        // Draw vertical gridlines only for yearly ticks
        ctx.strokeStyle = '#e0e0e0' // Gray color for gridlines
        ctx.lineWidth = 4
        ctx.setLineDash([])

        // ctx.beginPath()
        // ctx.moveTo(173, chart.chartArea.top - overshoot)
        // ctx.lineTo(173, chart.chartArea.bottom + overshoot)
        // ctx.stroke()

        this.yearlyTicks.forEach((tickDate, index) => {
          const xPixel = xAxis.getPixelForValue(tickDate)

          if (xPixel >= chart.chartArea.left && xPixel <= chart.chartArea.right) {
            ctx.beginPath()
            ctx.moveTo(xPixel, chart.chartArea.top - overshoot)
            ctx.lineTo(xPixel, chart.chartArea.bottom + overshoot)
            ctx.stroke()
          }
        })

        ctx.restore()
      },
    })

    this.renderChart(this.chartData, this.options)
    this.$emit('generateChartImage', this._chart.toBase64Image())
  },


  methods: {
    fillMissingDataPoints: function (originalData) {
      if (!originalData || originalData.length === 0) return []

      let yearlyTicks = this.createYearlyTicks(originalData)
      let existingDates = new Set()

      originalData.forEach(function (point) {
        existingDates.add(point.x.toString())
      })

      let filledData = originalData.slice()
      let lastKnownValue = null

      yearlyTicks.forEach(function (tickDate) {
        if (!existingDates.has(tickDate.toString())) {
          let precedingData = originalData.filter(function (point) {
            return new Date(point.x) <= tickDate
          })

          if (precedingData.length > 0) {
            lastKnownValue = precedingData[precedingData.length - 1].y
            filledData.push({
              x: tickDate,
              y: lastKnownValue,
            })
          }
        }
      })

      return filledData.sort(function (a, b) {
        return new Date(a.x).getTime() - new Date(b.x).getTime()
      })
    },

    createYearlyTicks: function (chartData) {
      if (!chartData || chartData.length === 0) return []

      let firstDate = new Date(chartData[0].x)
      let lastDate = new Date(chartData[chartData.length - 1].x)
      let ticks = [new Date(lastDate)]

      let currentDate = new Date(lastDate)
      while (currentDate > firstDate) {
        currentDate.setFullYear(currentDate.getFullYear() - 1)
        if (currentDate >= firstDate) {
          ticks.unshift(new Date(currentDate))
        }
      }

      return ticks
    },

    createTickConfiguration: function (yearlyTicks) {
      let self = this

      return {
        minRotation: 45,
        maxRotation: 45,
        fontSize: 35,
        fontColor: "black",
        padding: 40,
        autoSkip: false,
        source: 'data',
        maxTicksLimit: 50,
        callback: function (value, index, values) {
          let tickDate = self.parseTickDate(value)
          let isYearlyTick = yearlyTicks.some(function (yearlyTick) {
            return self.datesEqual(tickDate, yearlyTick)
          })

          return isYearlyTick ? self.formatTickDate(tickDate) : undefined
        },
      }
    },

    parseTickDate: function (value) {
      let parts = value.split('.')
      let day = parts[0]
      let month = parts[1]
      let year = parts[2]
      return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
    },

    datesEqual: function (date1, date2) {
      let d1 = new Date(date1)
      let d2 = new Date(date2)
      d1.setHours(0, 0, 0, 0)
      d2.setHours(0, 0, 0, 0)
      return d1.getTime() === d2.getTime()
    },

    formatTickDate: function (date) {
      return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear()
    },
  },
})
</script>



// WEBPACK FOOTER //
// ChartPortfolioHistory.vue?4004948d